import { Property } from 'csstype'
import React, { PropsWithChildren } from 'react'

import { StyledFlex } from './FlexStyled'

export interface FlexProps {
  alignItems?: Property.AlignItems
  alignSelf?: Property.AlignSelf
  columnGap?: Property.ColumnGap
  flex?: Property.Flex
  flexDirection?: Property.FlexDirection
  flexFlow?: Property.FlexFlow
  flexWrap?: Property.FlexWrap
  gap?: Property.Gap
  height?: Property.Height
  justifyContent?: Property.JustifyContent
  margin?: Property.Margin
  padding?: Property.Padding
  rowGap?: Property.RowGap
  width?: Property.Width
}

const Flex: React.FC<PropsWithChildren<FlexProps>> = ({
  alignItems,
  alignSelf,
  children,
  columnGap,
  flex,
  flexDirection,
  flexFlow,
  flexWrap,
  gap,
  height,
  justifyContent,
  margin,
  padding,
  rowGap,
  width,
}) => (
  <StyledFlex
    $alignItems={alignItems}
    $alignSelf={alignSelf}
    $columnGap={columnGap}
    $flex={flex}
    $flexDirection={flexDirection}
    $flexFlow={flexFlow}
    $flexWrap={flexWrap}
    $gap={gap}
    $height={height}
    $justifyContent={justifyContent}
    $margin={margin}
    $padding={padding}
    $rowGap={rowGap}
    $width={width}
  >
    {children}
  </StyledFlex>
)

export default Flex
